var _rect, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208,
    height: 208,
    fill: "none",
    viewBox: "0 0 208 208"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 207.992,
    fill: "#F2F2F2",
    rx: 8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.478,
    cy: 74.207,
    fill: "#CCC",
    rx: 40.764,
    ry: 40.762
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M103.997 123.344c46.873 0 84.903 37.855 85.184 84.66H18.815c.28-46.805 38.31-84.66 85.182-84.66"
  })));
};
export default SvgAvatar;